import 'reflect-metadata';
import './registerServiceWorker';

import {TypedJSON} from 'typedjson';

import 'roboto-fontface/css/roboto/roboto-fontface.css';

import {buildDependencyContainer} from './app.container';

import './packages/class-component-hooks';

import {Vue} from 'vue-property-decorator';

import App from './App.vue';
import {buildRouter} from './router';
import Router from 'vue-router';

import {loadStore} from './store';
import vuetify from '@/plugins/vuetify';

import '@/plugins/plugins';
import '@/packages/packages';
import '@/filters/filters';

import './model/lora/LoraPacket/LoraPacketKnownTypes';

class AppBootstrap {
  constructor() {
    TypedJSON.setGlobalConfig({
      errorHandler: ((e: any) => {
        throw e;
      }),
    });

    Vue.use(Router);

    this.loadDependencyContainer();
    this.loadVueApp();
  }

  private loadDependencyContainer(): void {
    // Load Dependency Container
    buildDependencyContainer();
  }

  private loadVueApp(): void {
    Vue.config.productionTip = false;

    const router = buildRouter();

    const store = loadStore();

    Vue.prototype.$store = store;

    new Vue({
      router,
      store,
      vuetify,
      render: (h) => h(App),
    }).$mount('#app');
  }
}

const app = new AppBootstrap();
